/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Dance_Fitness_TermsInputs */

const en_service_type_dance_fitness_terms = /** @type {(inputs: Service_Type_Dance_Fitness_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zumba, dance, dance workout`)
};

const pl_service_type_dance_fitness_terms = /** @type {(inputs: Service_Type_Dance_Fitness_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zumba, taniec, fitness taneczny, dance`)
};

/**
* | output |
* | --- |
* | "zumba, dance, dance workout" |
*
* @param {Service_Type_Dance_Fitness_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_dance_fitness_terms = /** @type {((inputs?: Service_Type_Dance_Fitness_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Dance_Fitness_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_dance_fitness_terms(inputs)
	return en_service_type_dance_fitness_terms(inputs)
});